import SettingsContainer from "./SettingsContainer";
import { useSelector, useDispatch } from "react-redux";
import {
  currentSelectedLanguage,
  restoreDefaults,
  setSearchedUserName,
  validateInput,
  storeSettingsData
} from "../../../../StateManagement/actions";
import SearchBar from "./SearchBar";
import AdminTabContainer from "./AdminTabs/AdminTabContainer";
import {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useNavigate } from "react-router-dom";
import APIRequest from "../../../../Services/commonAPIConsumer";
import WarnUnSaveChangesPopUp from "../../../Shared/UnSaveChangesWarnPopUp/WarnUnSaveChangesPopUp";
import Alert from "../../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import useValidateSettings from "../hooks/useValidateSettings";
import { defaultGeneralSettings, defaultDocumentSettings, defaultAdvancedSettings, defaultStorageSettings } from "./SettingsType";
const tabMap = {
  Personal: "personalTab",
  Company: "companyTab",
  Admin: "AdminTab",
};

const SettingContainerHeader = forwardRef(
  ({ tabMenuText, getActiveTabSettings, collapseAside, isTabClickSearch = false, searchedInputData }, ref) => {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const settingFor = useSelector((state) => state.settings.settingFor);
    const UserName = useSelector((state) => state.settings.searchedUser);
    const CompanyName = useSelector((state) => state.settings.searchedCompany);
    const settings = useSelector((state) => state.settings);
    const validInput = useSelector(state => state.settings.inValidInputs);
    const excludeControls = useSelector((state) => state.settings.excludeControls);
    const isRestoredToDefaults = useSelector((state) => state.settings.restoreDefaults);
    const { validateSettings } = useValidateSettings();

    const dispatch = useDispatch();
    const configLevel = useRef("");

    const Key = tabMap[settingFor === "User" ? "Personal" : settingFor];
    const settingConfigLevel = settings[Key]?.settingsData[0]?.configLevel;

    const userRole = localStorage.getItem("UserRole");
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const history = useNavigate();
    const [openLoader, setOpenLoader] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("");
    //const [onSearch, setOnSearch] = useState();
    const searchedUserName = useRef(UserName);
    const CompanyNameSearch = useRef(CompanyName);

    const apiCallRequired = useRef(false);
    const [populateCompany, setPopulateCompany] = useState({ searchText: "", companyName: "" });

    let className = "";
    if (settingFor === "Company") {
      className =
        `mb-3 tab-heading d-flex align-items-center justify-content-between mt-72 ${collapseAside}`;
    } else if (settingFor === "User") {
      className =
        "d-flex align-items-center justify-content-between comonheader-bg";
    }

    useEffect(() => {
      configLevel.current = "";
      if (userRole === "RDocsSupportAdmin" && settingFor === "Company" && CompanyName) {
        setPopulateCompany({ searchText: "", companyName: CompanyName });
        return;
      }
      setPopulateCompany({ searchText: "", companyName: "" });
      // searchedUserName.current = "";
      // CompanyNameSearch.current = "";
      dispatch(setSearchedUserName({ searchText: "", companyName: "" }));
    }, [settingFor]);

    // useEffect(() => {
    //   setTimeout(() => {
    //     setAlertMsg("");
    //     setAlertType("");
    //   }, 5000);
    // }, [alertType]);



    const showConfirmationPopup = () => {
      try {
        console.log(validInput);
        if (validInput.ip) {
          dispatch(validateInput({ value: !validInput.ip }))
          return;
        }
        const result = validateSettings();
        if (result !== true) {
          setAlertMsg(result.message);
          setAlertType(result.type);
          return;
        }
        const tabKey =
          tabMap[
          settings.settingFor === "User" ? "Personal" : settings.settingFor
          ];
        let commonSettings = [];
        let l1Settings = [];
        let l2Settings = [];
        let l3Settings = [];
        let cipherTextSettings = [];
        let floatingTextSettings = [];
        if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
          commonSettings = settings[tabKey]?.settingsData.find(
            (s) => s.settingFor === settings.defaultSetting
          ).commonSettings;
          l1Settings = settings[tabKey]?.settingsData.find(
            (s) => s.settingFor === settings.defaultSetting
          ).l1;
          l2Settings = settings[tabKey]?.settingsData.find(
            (s) => s.settingFor === settings.defaultSetting
          ).l2;
          l3Settings = settings[tabKey]?.settingsData.find(
            (s) => s.settingFor === settings.defaultSetting
          ).l3;
        } else if (settings[tabKey]?.selectedTab === "ContentSecurity") {
          commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
          cipherTextSettings = settings[tabKey]?.settingsData[0]?.cipherText;
          floatingTextSettings = settings[tabKey]?.settingsData[0]?.floatingText;
        }
        else {
          commonSettings = settings[tabKey]?.settingsData;
        }
        const settingsChanged = commonSettings.find(
          (setting) => setting?.isDataChanged
        );
        const l1SettingsChanged = l1Settings.find(
          (setting) => setting?.isDataChanged
        );
        const l2SettingsChanged = l2Settings.find(
          (setting) => setting?.isDataChanged
        );
        const l3SettingsChanged = l3Settings.find(
          (setting) => setting?.isDataChanged
        );
        const cipherTextSettingsChanged = cipherTextSettings.find(
          (setting) => setting?.isDataChanged
        );
        const floatingTextSettingsChanged = floatingTextSettings.find(
          (setting) => setting?.isDataChanged
        );
        apiCallRequired.current = (settingsChanged || l1SettingsChanged || l2SettingsChanged || l3SettingsChanged || cipherTextSettingsChanged || floatingTextSettingsChanged);
        setmodalIsOpen(true);
      } catch (error) {
        console.log(error);
      }
    };

    const handlerModelCancel = () => {
      setmodalIsOpen(false);
    };


    function customUpdateCommonSettingsData(commonSettings) {
      let ManageKeyValue = "";
      const LandingPage = commonSettings.find(s => s.type === "LandingPage");
      const ManageItem = commonSettings.find(s => s.type === "LandingPage_ManageItem");
      if (LandingPage?.isDataChanged || ManageItem?.isDataChanged) {
        if (LandingPage?.keyValue.includes("Manage")) {
          ManageKeyValue = `${LandingPage?.keyValue.split('_')[0]}_${ManageItem?.keyValue}`;
          commonSettings = commonSettings.map(s => {
            if (s.type === "LandingPage") {
              return {
                ...s,
                keyValue: ManageKeyValue,
                isDataChanged: ManageItem?.isDataChanged || s?.isDataChanged,
              };
            }
            return s;
          }).filter(s => s.type !== "LandingPage_ManageItem");
        }
      }

      const EDisclosure = commonSettings.find(s => s.type === "EDisclosure");
      if (EDisclosure?.isDataChanged) {
        commonSettings = commonSettings.map(s => {
          if (s.type === "TermsOfService") {
            return {
              ...s,
              overrideUserSetting: EDisclosure?.overrideUserSetting,
              lockSetting: EDisclosure?.lockSetting,
              isDataChanged: EDisclosure?.isDataChanged,
            };
          }
          return s;
        });
      }


      commonSettings = commonSettings.map(s => {
        if (s.type === "MaxPagesPerRPD" || s.type === "ImageResolution") {
          return {
            ...s,
            isDataChanged: s.keyValue !== s.prevValue,
          };
        }
        return s;
      });

      if (excludeControls?.length > 0) {
        const filteredExcludeControls = excludeControls.filter(
          type => type !== "MaxPagesPerRPD" && type !== "ImageResolution"
        );
        commonSettings = commonSettings.filter(s => !filteredExcludeControls.includes(s.type));
      }




      return commonSettings;
    }

    const SubmitChangedData = async (isApiCallRequired) => {
      apiCallRequired.current = isApiCallRequired;
      if (!apiCallRequired.current) {
        setmodalIsOpen(false);
        setAlertType("sucess");
        return;
      }
      setOpenLoader(true);
      const tabKey =
        tabMap[
        settings.settingFor === "User" ? "Personal" : settings.settingFor
        ];
      const isDirectSend =
        settings[tabKey]?.selectedTab === "DirectSendDefaults";
      const isContentSecurity =
        settings[tabKey]?.selectedTab === "ContentSecurity";
      let commonSettings = [];
      let l1Settings = [];
      let l2Settings = [];
      let l3Settings = [];
      let cipherTextSettings = [];
      let floatingTextSettings = [];
      let commonSettingsChanged = [];
      let l1SettingsChanged = [];
      let l2SettingsChanged = [];
      let l3SettingsChanged = [];
      let cipherTextSettingsChanged = [];
      let floatingTextSettingsChanged = [];
      let config = "";
      if (settings[tabKey]?.selectedTab === "DirectSendDefaults") {
        config = settings[tabKey]?.settingsData.find(
          (s) => s.settingFor === settings.defaultSetting
        ).configLevel;
        commonSettings = settings[tabKey]?.settingsData.find(
          (s) => s.settingFor === settings.defaultSetting
        ).commonSettings;
        l1Settings = settings[tabKey]?.settingsData.find(
          (s) => s.settingFor === settings.defaultSetting
        ).l1;
        l2Settings = settings[tabKey]?.settingsData.find(
          (s) => s.settingFor === settings.defaultSetting
        ).l2;
        l3Settings = settings[tabKey]?.settingsData.find(
          (s) => s.settingFor === settings.defaultSetting
        ).l3;
      }
      else if (isContentSecurity) {
        commonSettings = settings[tabKey]?.settingsData[0]?.commonContentSecuritySetting;
        cipherTextSettings = settings[tabKey]?.settingsData[0]?.cipherText;
        floatingTextSettings = settings[tabKey]?.settingsData[0]?.floatingText;
      } else {
        commonSettings = settings[tabKey]?.settingsData;
      }

      commonSettings = customUpdateCommonSettingsData(commonSettings);


      commonSettingsChanged = commonSettings
        .filter((setting) => setting.isDataChanged)
        .map((setting) => ({
          type: setting.type,
          keyvalue: setting.keyValue,
          keyCollection: setting.keyCollection || [],
          [isDirectSend || isContentSecurity ? "isOverride" : "overrideUserSetting"]:
            setting[isDirectSend || isContentSecurity ? "isOverride" : "overrideUserSetting"],
          [isDirectSend || isContentSecurity ? "isLock" : "lockSetting"]:
            setting[isDirectSend || isContentSecurity ? "isLock" : "lockSetting"],
        }));
      const isDirectSendDefaults =
        isDirectSend &&
        (isRestoredToDefaults.l1 ||
          isRestoredToDefaults.l2 ||
          isRestoredToDefaults.l3);
      if (isDirectSend) {

        if (isDirectSendDefaults) {

          if (isRestoredToDefaults.l1) {
            l1SettingsChanged = l1Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

          if (isRestoredToDefaults.l2) {
            l2SettingsChanged = l2Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

          if (isRestoredToDefaults.l3) {
            l3SettingsChanged = l3Settings.map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
          }

        } else {

          l1SettingsChanged = l1Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));

          l2SettingsChanged = l2Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));

          l3SettingsChanged = l3Settings
            .filter(s => s.isDataChanged)
            .map(s => ({
              type: s.type,
              keyvalue: s.keyValue,
              keyCollection: s.keyCollection,
              isOverride: s.isOverride,
              isLock: s.isLock,
            }));
        }
      }
      if (isContentSecurity) {
        if (isRestoredToDefaults.cipher || isRestoredToDefaults.floating) {
          if (isRestoredToDefaults.cipher) {
            cipherTextSettingsChanged = cipherTextSettings.map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }))
          }
          if (isRestoredToDefaults.floating) {
            floatingTextSettingsChanged = floatingTextSettings.map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }));
          }
        } else {
          cipherTextSettingsChanged = cipherTextSettings
            .filter((setting) => setting.isDataChanged)
            .map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }));
          floatingTextSettingsChanged = floatingTextSettings
            .filter((setting) => setting.isDataChanged)
            .map((setting) => ({
              type: setting.type,
              keyvalue: setting.keyValue,
              keyCollection: setting.keyCollection,
              isOverride: setting.isOverride,
              isLock: setting.isLock,
            }));
        }
      }
      if (isDirectSend || isContentSecurity) {
        let apiSettingsStr = {};
        if (isDirectSend) {
          apiSettingsStr = {
            SettingFor: settings.defaultSetting,
            SettingsForType: UserName !== "" ? 'User' : settingFor === "Admin" ? "Company" : settingFor,
            CompanyReferenceKey: settings[tabKey].settingsData.find(
              (s) => s.settingFor === settings.defaultSetting
            ).companyReferenceKey,
            SettingId: settings[tabKey].settingsData.find(
              (s) => s.settingFor === settings.defaultSetting
            ).id,
            Bowserlaguage: localStorage.getItem("language"),
            LoginUsername: localStorage.getItem("UserName"),
            UserEmail: settings[tabKey].settingsData.find(
              (s) => s.settingFor === settings.defaultSetting
            ).userEmail,
            CommonSettings: [...commonSettingsChanged],
            L1: [...l1SettingsChanged],
            L2: [...l2SettingsChanged],
            L3: [...l3SettingsChanged],
            Companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : CompanyNameSearch.current,
            Role: userRole,
          };
        } else if (isContentSecurity) {
          apiSettingsStr = {
            SettingsForType: UserName !== "" ? 'User' : settingFor === "Admin" ? "Company" : settingFor,
            CompanyReferenceKey: settings[tabKey].settingsData[0].companyReferenceKey,
            SettingId: settings[tabKey].settingsData[0].id,
            Bowserlaguage: localStorage.getItem("language"),
            LoginUsername: localStorage.getItem("UserName"),
            UserEmail: settings[tabKey].settingsData[0].userEmail,
            CommonContentSecuritySetting: [...commonSettingsChanged],
            CipherText: [...cipherTextSettingsChanged],
            FloatingText: [...floatingTextSettingsChanged],
            Companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : CompanyNameSearch.current,
            Role: userRole,
          };
        }
        const jsonData = JSON.stringify(apiSettingsStr);
        let response;
        if (isDirectSend) {
          response = await APIRequest.POSTSaveSettings(
            jsonData,
            `${process.env.REACT_APP_API + "/docs/SaveSettingGateway"}`
          );

        } else if (isContentSecurity) {
          response = await APIRequest.POSTSaveSettings(
            jsonData,
            `${process.env.REACT_APP_API + "/docs/SaveContentSecuritySettings"}`
          );
        }
        setOpenLoader(false);
        setmodalIsOpen(false);
        apiCallRequired.current = false;
        if (response === "Server maintenance") {
          history("/maintenance");
          return;
        } else if (
          response.errorMessage !== undefined &&
          response.errorMessage != ""
        ) {
          setAlertMsg(response.errorMessage);
          setAlertType("warning");
          return;
        } else if (response.statusText === "Inserted") {
          await getActiveTabSettings(tabMenuText, searchedUserName.current || UserName, CompanyNameSearch.current || CompanyName);
          setAlertType("sucess");
          dispatch(restoreDefaults());
          return;
        }
      }
      let apiSettingsStr = {
        SettingsForType: configLevel.current === "User" ? "User" : settingFor,
        SettingDetails: commonSettingsChanged,
        bowserlaguage: localStorage.getItem("language"),
        userEmail: (settingFor !== "User") ? searchedUserName.current || UserName : localStorage.getItem("UserName").toLowerCase(),
        role: userRole,
        companyname: (userRole !== "RDocsSupportAdmin") ? localStorage.getItem("Companyname") : CompanyNameSearch.current || CompanyName,
        loginUsername: localStorage.getItem("UserName").toLowerCase(),
      };
      var response = await APIRequest.POSTSaveSettings(
        JSON.stringify(apiSettingsStr),
        `${process.env.REACT_APP_API + process.env.REACT_APP_API_SaveSettings
        }`
      );
      setOpenLoader(false);
      setmodalIsOpen(false);
      apiCallRequired.current = false;
      if (response && response === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (response && response !== "Failed to fetch") {
        if (
          response.errorMessage == undefined ||
          response.errorMessage == ""
        ) {
          getActiveTabSettings(tabMenuText, searchedUserName.current || UserName, CompanyNameSearch.current || CompanyName);
          setAlertType("sucess");
          return;
        } else {
          setAlertMsg(response.errorMessage);
          setAlertType("warning");
          return;
        }
      } else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FailedtoSaveSetting + "."
        );
        setAlertType("warning");
        return;
      }

    };

    const onSearchHandler = (searchText, companyName, defaultTab) => {
      if (userRole === "RDocsCustomerAdmin" && searchText === "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EnterEmailAddress);
        setAlertType("warning");
        return;
      } else if (userRole === "RDocsSupportAdmin" && (searchText === "" && companyName === "")) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_validateCompanyOrUser);
        setAlertType("warning");
        return;
      }

      //setOnSearch(true);
      searchedUserName.current = searchText;
      CompanyNameSearch.current = companyName;
      if (searchText) {
        configLevel.current = "User";
      } else {
        configLevel.current = "";
      }
      dispatch(setSearchedUserName({ searchText, companyName }));
      getActiveTabSettings(
        settings[Key]?.selectedTab || tabMenuText || defaultTab,
        searchedUserName.current,
        (userRole === "RDocsCustomerAdmin") ? localStorage.getItem('Companyname') : CompanyNameSearch.current
      );
    };

    const onResetHandler = () => {
      //setOnSearch(false);
      searchedUserName.current = "";
      CompanyNameSearch.current = "";
      configLevel.current = "";
      dispatch(setSearchedUserName({ searchText: "", companyName: "" }));
      getActiveTabSettings(tabMenuText, "", "");
    };
    const restSetToDefaultValues = () => {
      const settingsData = {
        outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
        innerTabSelected: tabMenuText,
        Settings: [],
        restoreDefaultSettings: {},
      };

      const selectedTab = settings[Key]?.selectedTab;
      if (!selectedTab) return;

      let defaultSettings = [];
      switch (selectedTab) {
        case "General":
          defaultSettings = defaultGeneralSettings;
          break;
        case "DefaultDocumentSettings":
          defaultSettings = defaultDocumentSettings;
          break;
        case "Advance":
          defaultSettings = defaultAdvancedSettings;
          break;
        case "Storage":
          defaultSettings = defaultStorageSettings;
          break;
        default:
          return;
      }

      let anyChanged = false;

      // 👉 Company ignores lock, User respects lock
      const ignoreLock = settingFor === "Company";

      settingsData.Settings = settings[Key].settingsData.map(item => {
        const def = defaultSettings.find(d => d.type === item.type);
        if (!def) return item;

        let valueDiffers = false;
        if (item.type !== 'EDisclosure') {
          valueDiffers = item.prevValue?.toLowerCase() !== def.keyValue?.toLowerCase();
        }
        else {
          valueDiffers = item.prevValue?.toLowerCase() !== def.keyValue?.toLowerCase();
          if (!valueDiffers) {
            valueDiffers = isLevelFlagDifferent(item.keyCollection, def.keyCollection)
          }
        }

        const isLocked = item.lockSetting === "true";

        // USER tab → locked items should NOT change
        if (isLocked && !ignoreLock) {
          if (valueDiffers) anyChanged = true;

          return {
            ...item,
            isDataChanged: false,
          };
        }

        // COMPANY tab OR unlocked item → restore default
        if (valueDiffers) anyChanged = true;
        return {
          ...item,
          keyValue: def.keyValue,
          keyCollection:
            item.type === 'EDisclosure'
              ? item.keyCollection.map(kc => {
                const defKC = def.keyCollection.find(d => d.level === kc.level);
                return defKC
                  ? { ...kc, levelFlag: defKC.levelFlag }
                  : kc;
              })
              : item.keyCollection,
          isDataChanged: valueDiffers,
        };
      });
      settingsData.restoreDefaultSettings[selectedTab] = anyChanged;
      dispatch(storeSettingsData(settingsData));
    };

    const isLevelFlagDifferent = (itemCollection = [], defCollection = []) => {
      return itemCollection.some(item => {
        const defItem = defCollection.find(d => d.level === item.level);
        if (!defItem) return false;

        return item.levelFlag !== defItem.levelFlag;
      });
    };
    useImperativeHandle(ref, () => ({
      showConfirmationPopup,
      handlerModelCancel,
      SubmitChangedData,
    }));

    let activeClass = "";
    if (userRole === "RDocsSupportAdmin" && isTabClickSearch) {
      configLevel.current = UserName !== "" ? "User" : "";
      activeClass = "active show";
    } else if (userRole === "RDocsCustomerAdmin") {
      configLevel.current = UserName !== "" ? "User" : "";
      activeClass = "active show";
    } else if (userRole === "RDocsUser") {
      activeClass = "active show";
    } else {
      activeClass = "";
    }
    let disableRestoreButton = false;
    if (settingFor === "User") {
      const selectedTab = settings[Key]?.selectedTab;
      if (!selectedTab) return;
      let defaultSettings = [];
      switch (selectedTab) {
        case "General":
          defaultSettings = defaultGeneralSettings;
          break;
        case "DefaultDocumentSettings":
          defaultSettings = defaultDocumentSettings;
          break;
        case "Advance":
          defaultSettings = defaultAdvancedSettings;
          break;
        case "Storage":
          defaultSettings = defaultStorageSettings;
          break;
        default:
          defaultSettings = "";
          break;
      }
      if (defaultSettings !== "") {
        const currentSettings = settings[Key]?.settingsData || [];
        let considerShareVotes = currentSettings.find(s => s.type == "Voting" && s.keyValue === "false")
        if (considerShareVotes != undefined) {
          defaultSettings = defaultSettings.filter(s => s.type !== "ShareVotes")
        }
        if (currentSettings.length > 0) {
          const lockedCount = currentSettings.filter(
            (setting) => defaultSettings.find(s => s.type === setting.type) && setting.lockSetting === "true"
          ).length;
          disableRestoreButton = lockedCount === defaultSettings.length;
        }
      }
    }
    console.log('isTabClickSearch', isTabClickSearch);
    return (
      <>
        {openLoader ? <LoadingSpinner /> : null}
        <Alert
          alertType={alertType}
          alertMsg={alertMsg}
          setAlertMsg={setAlertMsg}
          setAlertType={setAlertType}
          className="alerthist"
          isfromSeetting="true"
          resetTrigger={tabMenuText}></Alert>
        <div
          className={`tabright-content${settingFor === "User" ? "2" : settingFor === "Admin" ? "3" : ""
            } p-0 ${collapseAside}`}>
          <div className="tab-content" id="v-tabs-tabContent">
            {settingFor === "Company" && (
              <SearchBar
                onSearch={onSearchHandler}
                onReset={onResetHandler}
                //onSearchInputChange={setOnSearch}
                collapseAside={collapseAside}
                populateCompany={populateCompany}
              />
            )}
            {settingFor === "User" && (
              <div className="mb-3 comontab-heading mt-50">
                <div className={className}>
                  <h6 className=" font-16 font-w600 ps-3 ">
                    {
                      selectedLanguage.LstLanguageCodes
                        .UI_viewingPersonalsettings
                    }
                  </h6>
                  {tabMenuText !== "Profile" && (
                    <div className="restor-button">
                      {tabMenuText !== "DirectSendDefaults" && tabMenuText !== "ContentSecurity" && (
                        <div className="btn"
                          aria-disabled={disableRestoreButton}
                          style={{
                            cursor: disableRestoreButton ? "not-allowed" : "pointer",
                            opacity: disableRestoreButton ? 0.6 : 1,
                            display: "inline"
                          }}>
                          <button
                            type="button"
                            className="btn btn-outline-success px-1rem me-3"
                            disabled={disableRestoreButton}
                            onClick={restSetToDefaultValues}
                          >
                            <div className="d-flex align-items-center">
                              <span
                                className="material-icons rotate-90"
                                style={{ fontSize: '20px', marginRight: '10px' }}
                              >
                                settings_backup_restore
                              </span>
                              {selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
                            </div>                  </button></div>
                      )}
                      <button
                        type="button"
                        className="btn sendsubmit px-2rem me-1"
                        style={{ margin: "0rem" }}
                        onClick={showConfirmationPopup}>
                        {selectedLanguage.LstLanguageCodes.UI_Save}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
            {settingFor === "Company" &&
              (userRole === "RDocsSupportAdmin" ||
                userRole === "RDocsCustomerAdmin") && (
                <div className={className}>
                  {isTabClickSearch && (
                    <>
                      <h6 className=" font-16 font-w600 ps-3 ">
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_viewingCompanysettings
                        }{" "}
                        {settingConfigLevel === "User"
                          ? searchedInputData.userEmail
                          : searchedInputData.companyName
                        }
                      </h6>
                      <div className="d-flex justify-content-end align-items-center gap-2" style={{ marginTop: "-0.25rem", marginBottom: "-0.30rem" }}>
                        {tabMenuText !== "DirectSendDefaults" && tabMenuText !== "ContentSecurity" && (
                          <button
                            type="button"
                            className="btn btn-outline-success px-1rem me-3 mb-1 pb-1 reset-button-company"
                            onClick={restSetToDefaultValues}
                          >
                            <div className="d-flex align-items-center">
                              <span
                                className="material-icons rotate-90"
                                style={{ fontSize: '20px', marginRight: '10px' }}
                              >
                                settings_backup_restore
                              </span>
                              {selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
                            </div>
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn sendsubmit px-2rem me-1"
                          onClick={showConfirmationPopup}>
                          {selectedLanguage.LstLanguageCodes.UI_Save}
                        </button>
                      </div>
                    </>
                  )}
                  {!isTabClickSearch && userRole === "RDocsSupportAdmin" && (
                    <>
                      <h6 className=" font-16 font-w600 ps-3 ">
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_SearchCompanyOrUser
                        }
                      </h6>
                    </>
                  )}
                  {!isTabClickSearch && userRole === "RDocsCustomerAdmin" && (
                    <>
                      <h6 className=" font-16 font-w600 ps-3 ">
                        {
                          selectedLanguage.LstLanguageCodes
                            .UI_viewingCompanysettings
                        }{" "}
                        {settingConfigLevel === "User"
                          ? searchedInputData.userEmail
                          : localStorage.getItem("Companyname")}
                      </h6>
                      <div className="d-flex justify-content-end align-items-center gap-2">
                        {tabMenuText !== "DirectSendDefaults" && tabMenuText !== "ContentSecurity" && (
                          <button
                            type="button"
                            className="btn btn-outline-success px-1rem me-3 mb-1 pb-1 reset-button-company"
                            onClick={restSetToDefaultValues}
                          >
                            <div className="d-flex align-items-center">
                              <span
                                className="material-icons rotate-90"
                                style={{ fontSize: '20px', marginRight: '10px' }}
                              >
                                settings_backup_restore
                              </span>
                              {selectedLanguage.LstLanguageCodes.UI_RestoreToDefaults}
                            </div>
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn sendsubmit px-2rem me-1"
                          onClick={showConfirmationPopup}>
                          {selectedLanguage.LstLanguageCodes.UI_Save}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              )}
            {settingFor === "Admin" && <AdminTabContainer />}
            {settingFor !== "Admin" && (
              <div
                className={`tab-pane fade rounded p-2 ${activeClass}`}
                id={`v-tabs`}
                role="tabpanel"
                aria-labelledby={`v-tabs`}>
                {tabMenuText !== "Profile" && (
                  <div
                    className={`mb-2 row align-items-center mt-5r tabsborder  ${settingFor === "User"
                      ? "fixed-positonPersonal"
                      : "fixed-positon"
                      }`}>
                    <div className="col-sm-3">
                      <label
                        htmlFor="inputdateFormat"
                        className="col-form-label font-w600 control res-w cursorDefault">
                        {selectedLanguage.LstLanguageCodes.UI_Option}
                      </label>
                    </div>

                    <div className="col-sm-4 text-left">
                      <label
                        htmlFor="inputdateFormat"
                        className="col-form-label font-w600 control res-w cursorDefault">
                        {selectedLanguage.LstLanguageCodes.UI_DefaultSettings}
                      </label>
                    </div>

                    {settingFor === "Company" &&
                      settingConfigLevel !== "User" && (
                        <div className="col-sm-2 text-center px-0">
                          <label
                            htmlFor="inputdateFormat"
                            className="col-form-label font-w600 control res-w cursorDefault">
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_OverrideUserSettings
                            }
                          </label>
                        </div>
                      )}
                    {settingFor === "Company" && (
                      <div className="col-sm-2 text-center ps-2">
                        <label
                          htmlFor="inputdateFormat"
                          className="col-form-label font-w600 control res-w cursorDefault">
                          {selectedLanguage.LstLanguageCodes.UI_LockSettings}
                        </label>
                      </div>
                    )}
                    <div
                      className={`${settingFor === "Company"
                        ? "col-sm-1 history-column-company"
                        : "col-sm-2 history-column"
                        } text-center`}>
                      <label
                        htmlFor="inputdateFormat"
                        className="col-form-label font-w600 control res-w cursorDefault">
                        {selectedLanguage.LstLanguageCodes.UI_History}
                      </label>
                    </div>
                  </div>
                )}

                {userRole === "RDocsSupportAdmin" && isTabClickSearch && (
                  <>
                    <SettingsContainer
                      tabMenuText={tabMenuText}
                      configLevel={settingConfigLevel}
                    />
                  </>
                )}
                {(userRole === "RDocsCustomerAdmin" ||
                  userRole === "RDocsUser") && (
                    <>
                      <SettingsContainer
                        tabMenuText={tabMenuText}
                        configLevel={settingConfigLevel}
                      />
                    </>
                  )}
              </div>
            )}
          </div>
        </div>
        <WarnUnSaveChangesPopUp
          isOpen={modalIsOpen}
          onCancel={handlerModelCancel}
          onConfirm={SubmitChangedData}
        />
      </>
    );
  }
);

export default SettingContainerHeader;
